onComplete(function () {
	setInterval(() => {
		const statusElements = document.querySelectorAll(".blog-field-status");
		statusElements.forEach((el) => {
			const statusText = el.textContent.trim();

			if (statusText === "Onder bod") {
				el.style.backgroundColor = "var(--secondary)";
			} else if (statusText === "Beschikbaar") {
				el.style.backgroundColor = "var(--secondary)";
			} else {
				el.style.backgroundColor = "var(--primary)";
			}
		});
	}, 1000);
});